var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping_bag",
    "data-name": "shopping bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,25.15,25.28,10.5a2.93,2.93,0,0,0-3-2.5H20.93c0-.19,0-.38-.06-.57-.22-1.54-.41-2.87-1.59-4a4.51,4.51,0,0,0-6.56,0c-1.18,1.14-1.37,2.47-1.59,4,0,.19,0,.38-.06.57H9.69a2.93,2.93,0,0,0-3,2.5L5,25.15a4.13,4.13,0,0,0,1,3.26A4.87,4.87,0,0,0,9.72,30H22.28a4.87,4.87,0,0,0,3.64-1.59A4.13,4.13,0,0,0,27,25.15ZM13.11,7.71c.22-1.52.34-2.21,1-2.85A2.78,2.78,0,0,1,16,4a2.78,2.78,0,0,1,1.89.86c.66.64.78,1.33,1,2.85,0,.1,0,.19,0,.29H13.09C13.1,7.9,13.1,7.81,13.11,7.71ZM24.42,27.08a2.83,2.83,0,0,1-2.14.92H9.72a2.83,2.83,0,0,1-2.14-.92A2.14,2.14,0,0,1,7,25.38l1.7-14.65a.94.94,0,0,1,1-.73H11c0,.38.05.76.1,1.14a1,1,0,1,0,2-.28c0-.29,0-.57-.06-.86H19c0,.29,0,.57-.06.86A1,1,0,0,0,19.74,12h.14a1,1,0,0,0,1-.86c.05-.38.08-.76.1-1.14h1.34a.94.94,0,0,1,1,.73L25,25.38A2.14,2.14,0,0,1,24.42,27.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.3e83be19c3920e78f8bcf3ce6a599aed.svg";
export { ForwardRef as ReactComponent };